var exports = {
  "O": "xe533113f--014554--railway-item",
  "k": "xe533113f--014554--travel-info",
};

module.exports = exports;
